import { Component, Input } from '@angular/core';

@Component({
    selector: 'cmn-errors',
    templateUrl: './error.component.html',
    styleUrls: [ './error.component.scss' ],
})

export class ErrorComponent {
    @Input() public readonly name: string;
    @Input() public readonly when: string | string[] = 'dirty';
}
